import React, { Component } from 'react';
import image from './cryptomonedas.png';
import Form from './components/Form';
import axios from 'axios';
import Result from './components/Result';
import Spinner from './components/Spinner';

class App extends Component {

  state = {
    result: '',
    currencySelect: '',
    cryptoSelect: '',
    loading: false
  }

  quoteCryptoCurrency = quoting => {
    const {currency, cryptoCurrency} = quoting
    const url = `https://min-api.cryptocompare.com/data/price?fsym=${cryptoCurrency}&tsyms=${currency}`

    axios.get(url)
      .then(res => {
        this.setState({
          result: res.data[currency],
          loading: true
        }, () => {
          setTimeout(() => {
            this.setState({
              loading: false
            })
          }, 3000)
        })
      })

  }

  render() {

    const result = this.state.loading ? <Spinner/> : <Result price={this.state.result}/>

    return (
      <div className="container">
          <div className="row">
              <div className="one-half column">
                <img src={image} alt="imagen" className="logotipo"/>
              </div>
              <div className="one-half column">
                <h1>Cotiza Criptomonedas al instante</h1>
                <Form
                  quoteCryptoCurrency={this.quoteCryptoCurrency}
                />
                {result}
              </div>
          </div>
      </div>
    );
  }
}

export default App;
